var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loadingFlag,
          expression: "loadingFlag",
        },
      ],
      class: [((_obj = {}), (_obj["active"] = _vm.active), _obj), "rect-shape"],
    },
    [
      _vm.editBarViewShowFlag
        ? _c("EditBarView", {
            attrs: {
              element: _vm.element,
              "show-position": _vm.showPosition,
              "panel-id": _vm.panelInfo.id,
              "chart-title": _vm.chart.title || _vm.chart.name,
              "is-edit": _vm.isEdit,
              "view-id": _vm.element.propValue.viewId,
            },
            on: { showViewDetails: _vm.openChartDetailsDialog },
          })
        : _vm._e(),
      _vm.requestStatus === "error"
        ? _c("div", { staticClass: "chart-error-class" }, [
            _c("div", { staticClass: "chart-error-message-class" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.message) +
                  "," +
                  _vm._s(_vm.$t("chart.chart_show_error")) +
                  "\n      "
              ),
              _c("br"),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("chart.chart_error_tips")) + "\n    "
              ),
            ]),
          ])
        : _vm._e(),
      _vm.chart.isPlugin
        ? _c("plugin-com", {
            ref: _vm.element.propValue.id,
            staticClass: "chart-class",
            attrs: {
              "component-name": _vm.chart.type + "-view",
              obj: {
                active: _vm.active,
                chart: _vm.chart,
                trackMenu: _vm.trackMenu,
                searchCount: _vm.searchCount,
                terminalType: _vm.scaleCoefficientType,
              },
              chart: _vm.chart,
              "track-menu": _vm.trackMenu,
              "search-count": _vm.searchCount,
              "terminal-type": _vm.scaleCoefficientType,
              scale: _vm.scale,
              "theme-style": _vm.element.commonBackground,
              "canvas-style-data": _vm.canvasStyleData,
            },
            on: {
              onChartClick: _vm.chartClick,
              onJumpClick: _vm.jumpClick,
              "trigger-edit-click": _vm.pluginEditHandler,
            },
          })
        : _vm.richTextViewShowFlag
        ? _c("de-rich-text-view", {
            ref: _vm.element.propValue.id,
            attrs: {
              scale: _vm.scale,
              element: _vm.element,
              "prop-value": _vm.element.propValue.textValue,
              active: _vm.active,
              "edit-mode": _vm.editMode,
              "data-row-select": _vm.dataRowSelect,
              "data-row-name-select": _vm.dataRowNameSelect,
            },
          })
        : _vm.charViewShowFlag
        ? _c("chart-component", {
            ref: _vm.element.propValue.id,
            staticClass: "chart-class",
            attrs: {
              chart: _vm.chart,
              "track-menu": _vm.trackMenu,
              "search-count": _vm.searchCount,
              "terminal-type": _vm.scaleCoefficientType,
              scale: _vm.scale,
              "theme-style": _vm.element.commonBackground,
              active: _vm.active,
            },
            on: { onChartClick: _vm.chartClick, onJumpClick: _vm.jumpClick },
          })
        : _vm.charViewG2ShowFlag
        ? _c("chart-component-g2", {
            ref: _vm.element.propValue.id,
            staticClass: "chart-class",
            attrs: {
              chart: _vm.chart,
              "track-menu": _vm.trackMenu,
              "search-count": _vm.searchCount,
              scale: _vm.scale,
            },
            on: { onChartClick: _vm.chartClick, onJumpClick: _vm.jumpClick },
          })
        : _vm.charViewS2ShowFlag
        ? _c("chart-component-s2", {
            ref: _vm.element.propValue.id,
            staticClass: "chart-class",
            attrs: {
              chart: _vm.chart,
              "terminal-type": _vm.scaleCoefficientType,
              "track-menu": _vm.trackMenu,
              "search-count": _vm.searchCount,
            },
            on: {
              onChartClick: _vm.chartClick,
              onJumpClick: _vm.jumpClick,
              onPageChange: _vm.pageClick,
            },
          })
        : _vm.tableShowFlag
        ? _c("table-normal", {
            ref: _vm.element.propValue.id,
            staticClass: "table-class",
            attrs: {
              "show-summary": _vm.chart.type === "table-normal",
              chart: _vm.chart,
            },
            on: { onPageChange: _vm.pageClick },
          })
        : _vm.labelShowFlag
        ? _c("label-normal", {
            ref: _vm.element.propValue.id,
            staticClass: "table-class",
            attrs: { chart: _vm.chart },
          })
        : _vm.labelTextShowFlag
        ? _c("label-normal-text", {
            ref: _vm.element.propValue.id,
            staticClass: "table-class",
            attrs: {
              chart: _vm.chart,
              "track-menu": _vm.trackMenu,
              "search-count": _vm.searchCount,
            },
            on: { onChartClick: _vm.chartClick, onJumpClick: _vm.jumpClick },
          })
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { position: "absolute", left: "8px", bottom: "8px" } },
        [
          _c("drill-path", {
            attrs: {
              "drill-filters": _vm.drillFilters,
              "theme-style": _vm.element.commonBackground,
            },
            on: { onDrillJump: _vm.drillJump },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-css",
          attrs: {
            visible: _vm.chartDetailsVisible,
            width: "80%",
            "destroy-on-close": true,
            "show-close": true,
            "append-to-body": true,
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.chartDetailsVisible = $event
            },
          },
        },
        [
          _vm.chartDetailsVisible
            ? _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "70px",
                    top: "15px",
                  },
                },
                [
                  _vm.showChartInfoType === "enlarge" &&
                  _vm.hasDataPermission("export", _vm.panelInfo.privileges) &&
                  _vm.showChartInfo &&
                  _vm.showChartInfo.type !== "symbol-map"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "el-icon-picture-outline",
                          attrs: { size: "mini" },
                          on: { click: _vm.exportViewImg },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("chart.export_img")) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.showChartInfoType === "details" &&
                  _vm.hasDataPermission("export", _vm.panelInfo.privileges)
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.exportExcel },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "ds-icon-excel",
                            attrs: { "icon-class": "ds-excel" },
                          }),
                          _vm._v(
                            _vm._s(_vm.$t("chart.export")) + "Excel\n      "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.chartDetailsVisible
            ? _c("user-view-dialog", {
                ref: "userViewDialog",
                attrs: {
                  chart: _vm.showChartInfo,
                  "chart-table": _vm.showChartTableInfo,
                  "canvas-style-data": _vm.canvasStyleData,
                  "open-type": _vm.showChartInfoType,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "mobile-dialog-css",
          attrs: {
            visible: _vm.mobileChartDetailsVisible,
            fullscreen: true,
            "append-to-body": true,
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.mobileChartDetailsVisible = $event
            },
          },
        },
        [
          _vm.mobileChartDetailsVisible
            ? _c("user-view-mobile-dialog", {
                attrs: {
                  "canvas-style-data": _vm.canvasStyleData,
                  chart: _vm.showChartInfo,
                  "chart-table": _vm.showChartTableInfo,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }